module.exports = __webpack_public_path__ + "media/10.ded77514.wav";